<script setup>
import { productListAPI, getBannerAPI, getTotalSalesTopAPI, getYesterdaySalesTopAPI } from '@/apis/home'
import { getCategoryFilterAPI } from '@/apis/category'
import { getIpAPI, getContactDetailsAPI } from "@/apis/user"

import { onMounted, ref } from 'vue'
import { maskName } from '@/utils/index'
import GoodsItem from './components/GoodsItem.vue'
import DragBall from './components/floatDrag.vue'

import HotSale from './components/HotSale.vue'
import { useMeta } from 'vue-meta';
import { useRouter } from 'vue-router'
const router = useRouter()
import { useI18n } from 'vue-i18n'
const { t, locale } = useI18n();
import { useUserStore } from '@/stores/userStore'
const userStore = useUserStore()


const categoryList = ref([])
const discord = ref('')
const getIp = async () => {

    const res = await getIpAPI()
    if (res.code == 0) {
        localStorage.setItem('countryCode', res.data.countryCode);
        setLang(res.data.countryCode)
    }

}
/**
 * 获取联系方式
 */
const getContactDetails = async () => {
    const res = await getContactDetailsAPI()
    if (res.code == 0) {
        if (res.data.data) {
            discord.value = res.data.data[0]?.discord || ''
            
        }
    }

}
const openDiscord = () => {
    console.log('discord.value', discord.value)
    window.open(discord.value);
}
const toSearch = (i, f) => {
    router.push({ path: '/category/sub/4/1' })
}
//根据ip判断显示那种语言
const setLang = (code) => {
    console.log('判断语言')
    if (code == 'ARG' || code == 'COL' || code == 'MEX' || code == 'ESP' || code == 'CHL') {//西班牙
        localStorage.setItem('language', 'ESP');
    } else if (code == 'BR') {//葡萄牙语
        localStorage.setItem('language', 'PCP');
    } else if (code == 'BEL' || code == 'NL') {//荷兰
        localStorage.setItem('language', 'NED');
    } else if (code == 'POL') {//波兰语
        localStorage.setItem('language', 'PL');
    } else if (code == 'DE') {//德语
        localStorage.setItem('language', 'DE');
    } else if (code == 'FRA') {//法语
        localStorage.setItem('language', 'PCF');
    } else if (code == 'ITA') {//意大利
        localStorage.setItem('language', 'Ita');
    } else if (code == 'CHN' || code == 'HK') {
        localStorage.setItem('language', 'ZN');
    } else {
        localStorage.setItem('language', 'en_US');
    }
    getCategoryFilter()
}
/**
 * 获取商品分类
 */
const getCategoryFilter = async () => {
    let language = localStorage.getItem('language');
    console.log('语言', language)
    if (language == 'zh-cn') {
        language = 'zn'
    }
    const res = await getCategoryFilterAPI({ iso: language.toLowerCase() })
    if (res.code == 0) {
        categoryList.value = res.data.categoryList
        let item = { id: 99999, name: t('setup61') }
        categoryList.value.unshift(item);
    }
}

const toDetail = (id) => {
    router.push({ path: '/detail/' + id })

}
const bannerList = ref();
/**
 * 获取banner
 */
const getBanner = async () => {
    const res = await getBannerAPI()
    if (res.code == 0) {
        bannerList.value = res.data.data
    }
}
const totalSalesTop = ref();
const getTotalSalesTop = async () => {
    const res = await getTotalSalesTopAPI({ page: 1, page_size: 5 })
    if (res.code == 0) {
        totalSalesTop.value = res.data.data
    }
}
const yesterdaySalesTop = ref();
const getYesterdaySalesTop = async () => {
    const res = await getYesterdaySalesTopAPI()
    if (res.code == 0) {
        yesterdaySalesTop.value = res.data.data.slice(0, 4)
    }
}
const isMobile = ref(false);//false代表pc
const isIOS =ref(false)
const isIOSDialog=ref(false)
const islanlanguage=ref()
onMounted(() => {
    islanlanguage.value=localStorage.getItem('language');
    getBanner();
    getTotalSalesTop()
    getYesterdaySalesTop()
    getContactDetails()
    const COUNTRYcode = localStorage.getItem('countryCode')
    if (COUNTRYcode) {
        getCategoryFilter()
    } else {
        getIp()
    }

    // getCategoryFilter();
    getProductList()
    useMeta({
        title: '51Shopy - Your Global Online Shopping Destination for Affordable and Quality Products',
        meta: [
            { name: 'keywords', content: 'online shopping, global shopping, affordable products, quality goods, clothing, digital products, home supplies, furniture, adult products, shoes, international e-commerce' },
            { name: 'description', content: '51Shopy is a global online shopping platform offering high-quality and affordable products. Explore a wide range of items including clothing, digital gadgets, home supplies, furniture, adult products, shoes, and more. Enjoy a seamless and convenient shopping experience with worldwide delivery.' }
        ]
    });
    isIOS.value = /iPhone/i.test(navigator.userAgent);
   
    isMobile.value = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    console.log('Is mobile device:', isMobile.value);
     // 可以在组件挂载后检查是否有 deferredPrompt 事件
    //  if (window.deferredPrompt) {
    //     // 可以在这里显示弹窗，或者在用户完成某些操作后显示
    //     showInstallPrompt();
    //   }
    checkFirstVisit();
})
// 检查是否是从桌面启动
function isLaunchedFromHomeScreen() {
  const isStandalone = window.matchMedia('(display-mode: standalone)').matches
  const isFromPWA = new URLSearchParams(window.location.search).has('source=pwa')
  return isStandalone || isFromPWA
}

const checkFirstVisit = () => {

if (isLaunchedFromHomeScreen()) {
  console.log('从桌面启动，显示启动页')
} else {//普通链接访问
   
      
      if (window.Telegram?.WebApp.initData!=="") {
        console.log("运行在Telegram环境中");
       
      }else{
        if(isIOS.value==true){
            const hasVisited = sessionStorage.getItem('hasVisited');
            if (!hasVisited) {
                isIOSDialog.value=true
                sessionStorage.setItem('hasVisited', 'true');
            }
        
        }
      }
    
}
   
};
//pwa
// window.addEventListener('beforeinstallprompt', (e) => {
//   e.preventDefault();
//   window.deferredPrompt = e;
//   console.log('登录',window.deferredPrompt)
// }); 
// //这个函数可以被调用来触发安装提示
// const showInstallPrompt = () => {
//   if (window.deferredPrompt) {
//     window.deferredPrompt.prompt();
//     window.deferredPrompt.userChoice.then((choiceResult) => {
//       if (choiceResult.outcome === 'accepted') {
//         console.log('用户接受了添加到主屏幕');
//         // 执行添加到主屏幕后的相关操作
//       } else {
//         console.log('用户拒绝了添加到主屏幕');
//         // 执行用户拒绝后的相关操作，例如显示提示或者隐藏添加按钮
//       }
//       window.deferredPrompt = null;
//     });
//   } else {
//     console.log('没有可用的 deferredPrompt 事件');
//     alert('没有可用的 deferredPrompt 事件')
//   }
// };
// 总数量
const total = ref(0)
// 获取订单列表
const ProductList = ref([])
const params = reactive({
    fromData: {
        categoryId: 99999,
        page: 1,
        pageSize: 20,
        userId: userStore.userInfo.id
    }

})
const activeId = ref(99999);
const changeTab = (id, event) => {

    // 如果选择的和当前激活的不同
    if (id !== activeId.value) {
        params.fromData.page = 1
        activeId.value = id;
        params.fromData.categoryId = activeId.value
        console.log(activeId.value)
        // 计算当前按钮的位置，看是否需要移动
        const spanLeft = event.clientX; // 当前点击的元素左边距离
        const divBox = document.querySelector(".select-tab").clientWidth / 2; // 点击的元素一半宽度
        const totalWidths = document.body.clientWidth; // 屏幕总宽度
        const widths = totalWidths / 2; // 一半的屏幕宽度
        const spanRight = totalWidths - spanLeft; // 元素的右边距离
        const scrollBox = document.querySelector(".fixed-nav"); // 获取最外层的元素
        const scrollL = scrollBox.scrollLeft; // 滚动条滚动的距离
        // 当元素左边距离 或者 右边距离小于100时进行滑动
        if (spanRight < 100 || spanLeft < 100) {
            scrollBox.scrollLeft = scrollL + (spanLeft - widths) + divBox;
        }
        getProductList();
    }
}
const pcchangeTab = (id, event) => {
    console.log('spanLeft', event)
    // 如果选择的和当前激活的不同
    if (id !== activeId.value) {
        params.fromData.page = 1
        activeId.value = id;
        params.fromData.categoryId = activeId.value
        // 计算当前按钮的位置，看是否需要移动

        const spanLeft = event.clientX; // 当前点击的元素左边距离

        const divBox = document.querySelector(".select-tab").clientWidth / 2; // 点击的元素一半宽度
        const totalWidths = 1200; // 屏幕总宽度
        const widths = totalWidths; // 一半的屏幕宽度
        const spanRight = totalWidths - spanLeft; // 元素的右边距离
        const scrollBox = document.querySelector(".fixed-nav"); // 获取最外层的元素
        const scrollL = scrollBox.scrollLeft; // 滚动条滚动的距离

        console.log('scrollL', spanRight, spanLeft)
        // 当元素左边距离 或者 右边距离小于100时进行滑动
        if (spanRight < 100 || spanLeft < 100) {
            scrollBox.scrollLeft = scrollL + (spanLeft - widths) + divBox;
            console.log(scrollBox.scrollLeft)

        } else if (spanRight > 400) {
            scrollBox.scrollLeft = 0
        }
        getProductList();
    }
}


const isData = ref(false)
const getProductList = async () => {

    const res = await productListAPI(params.fromData)
    if (res.code == 0) {
        ProductList.value = res.data.data
        total.value = res.data.total

        if (total.value == 0) {
            isData.value = true
        } else {
            isData.value = false
        }
        console.log(isData.value)
    }

}

const loading = ref(false)
const noMore = computed(() => {
    if (ProductList.value) {
        if (ProductList.value.length >= total.value) {
            return true;
        } else {
            return false;
        }
    }
})
const disabled = computed(() => loading.value || noMore.value)
const load = () => {

    loading.value = true
    setTimeout(async () => {
        params.fromData.page++
        const res = await productListAPI(params.fromData)
        if (res.data.data) {
            ProductList.value = [...ProductList.value, ...res.data.data]
            loading.value = false
        }
    }, 10)
}
</script>

<template>
    <div :class="isMobile ? 'pg-phone' : ''">
        <div class="pg-top">
            <div class="top-l" v-if="isMobile == false">
                <div class="hot-title">{{ t('setup437') }}</div>
                <div class="hot-group">
                    <HotSale v-for="(i, index) in yesterdaySalesTop" :key="index" :goods="i" :type="'yesterday'" />
                </div>
            </div>
            <div class="top-r">
                <div v-if="bannerList">
                    <div class="banner" v-if="isMobile == false">
                        <!-- 111 -->
                        <!-- 2222 -->
                        <el-carousel :interval="10000" arrow="always" height="360px">
                            <el-carousel-item v-for="item in bannerList" :key="item">
                                <component :is="item.jumpUrl ? 'a' : 'div'"
                                    v-bind="item.jumpUrl ? { href: item.jumpUrl, target: '_blank' } : {}">
                                    <img :src="item.imageUrl" :alt="item.altText || 'carousel-image'"
                                        class="carouselImg" loading="lazy">
                                </component>
                            </el-carousel-item>
                        </el-carousel>
                    </div>
                    <div class="banner" v-else>
                        <el-carousel :interval="5000" arrow="always" height="150px"
                            style="border-radius: 10px; overflow: hidden;">
                            <el-carousel-item v-for="item in bannerList" :key="item"
                                style="height: 150px;border-radius: 10px; overflow: hidden;">
                                <!-- <h3 text="2xl" justify="center">{{ item }}</h3> -->

                                <a :href="item.jumpUrl" target="_blank" v-if="item.jumpUrl">
                                    <img :src="item.imageUrl" alt="" srcset="" class="carouselImg">
                                </a>
                                <a href="#" v-else>
                                    <img :src="item.imageUrl" alt="" srcset="" class="carouselImg">
                                </a>
                            </el-carousel-item>
                        </el-carousel>
                    </div>
                </div>
            </div>
        </div>
        <div class="shopping-steps-container">
            <div class="step-slogan">{{ t('setup666') }}</div>
            <div class="step-container">
                <div class="step-item">
                    <div class="step-icon"></div>
                    <div class="step-title">{{ t('setup658') }}</div>
                    <p class="step-content">{{ t('setup659') }}</p>
                </div>
                <div class="step-item">
                    <div class="step-icon icon2"></div>
                    <div class="step-title">{{ t('setup660') }}</div>
                    <p class="step-content">{{ t('setup661') }}</p>
                </div>
                <div class="step-item">
                    <div class="step-icon icon3"></div>
                    <div class="step-title">{{ t('setup662') }}</div>
                    <p class="step-content">{{ t('setup663') }}</p>
                </div>
                <div class="step-item">
                    <div class="step-icon icon4"></div>
                    <div class="step-title">{{ t('setup664') }}</div>
                    <p class="step-content">{{ t('setup665') }}</p>
                </div>
            </div>
        </div>

        <div class="shopping-steps-container-phone">
            <div class="step-slogan">{{ t('setup666') }}</div>
            <div class="step-container">
                <div class="step-item">
                    <div class="step-icon"></div>
                  <div class="step-title">{{ t('setup658') }}</div>
                    <!--   <p class="step-content">{{ t('setup659') }}</p> -->
                </div>
                <div class="step-item">
                    <div class="step-icon icon2"></div>
                    <div class="step-title">{{ t('setup660') }}</div>
                    <!-- <p class="step-content">{{ t('setup661') }}</p> -->
                </div>
                <div class="step-item">
                    <div class="step-icon icon3"></div>
                    <div class="step-title">{{ t('setup662') }}</div>
                    <!-- <p class="step-content">{{ t('setup663') }}</p> -->
                </div>
                <div class="step-item">
                    <div class="step-icon icon4"></div>
                    <div class="step-title">{{ t('setup664') }}</div>
                    <!-- <p class="step-content">{{ t('setup665') }}</p> -->
                </div>
            </div>
        </div>

        <div class="time-sale" v-if="isMobile == false">
            <div class="time-line">
                <div class="sale-icon">
                    <svg-icon icon-class="timesale" style="width: 34px;height: 31px;" />
                </div>
                <div class="sale-title">{{ t('setup438') }}</div>
                <div class="sale-btn" @click="toSearch">more</div>
            </div>
            <div class="sale-group">
                <HotSale v-for="(i, index) in totalSalesTop" :key="index" :goods="i" :type="'now'" />
                <div style="width: 20%;"></div>
                <div style="width: 20%;"></div>
                <div style="width: 20%;"></div>
                <div style="width: 20%;"></div>
            </div>
        </div>

        <div class="container">

            <section class="theme-list" v-if="isMobile == false">
                <div class="fixed-nav" ref="fixednav">
                    <div class="fixed-nav-content">
                        <p v-for="(item, index) in categoryList" :key="index"
                            :class="['tab-title', activeId === item.id && 'select-tab']"
                            @click="pcchangeTab(item.id, $event)">
                            {{ item.name }}
                        </p>
                    </div>
                </div>
            </section>
            <section class="theme-list" v-else>
                <div class="fixed-nav" ref="fixednav">
                    <div class="fixed-nav-content">
                        <p v-for="(item, index) in categoryList" :key="index"
                            :class="['tab-title', activeId === item.id && 'select-tab']"
                            @click="changeTab(item.id, $event)">
                            {{ item.name }}
                        </p>
                    </div>
                </div>
            </section>
        </div>

        <div class="content">
            <div class="goods-list" v-if="isData == false">

                <div class="body" v-infinite-scroll="load" :infinite-scroll-disabled="disabled">

                    <GoodsItem v-for="(Product, index) in ProductList" :key="index" :goods="Product" />
                </div>
                <p v-if="loading" style="text-align: center;padding: 20px 0 10px 0;">Loading...</p>
                <p v-if="noMore" style="text-align: center;padding: 20px 0 10px 0;">No more</p>

            </div>
            <div v-else>
                <el-empty :description="t('setup11')">

                </el-empty>
            </div>
        </div>
        <!-- <DragBall v-if="isMobile" :distanceRight="'0'" :distance-bottom="'150'" :token="userStore.userInfo.token"> </DragBall> -->
        <div class="fixed-box">
            <div v-if="isMobile && userStore.userInfo.token" @click="router.push('/customerPage')">
                <img src="../../assets/images/customer.png" alt="" />
            </div>
            <div v-if="isMobile" @click="openDiscord()">
                <img src="../../assets/images/dis.png" alt="" />
            </div>
        </div>
        <el-drawer v-model="isIOSDialog" direction="btt"  :show-close="false" size="50%" style="
    width: 90%;
    margin: auto;
    border-radius: 7px;
    margin-bottom: 5%;">
            <template #header="{ titleId, titleClass }">
                    <div class="showDialogtitle" :id="titleId" style="font-size: 17px;text-align: center;">{{ $t('setup681') }}</div>
                    <div style="width: 15px;height: 15px;margin-top: -7px;" @click="isIOSDialog = false">
                        <img src="../../assets/images/closure.png" alt="" srcset="">
                    </div>
                    </template>
           <div style="height: 100%;object-fit: contain;  ">
             <img src="../../assets/images/ios1.png" alt="" srcset=""  style="margin-top: -15px;padding-bottom: 20px;">
             <img v-if="islanlanguage!='ZN'" src="../../assets/images/en-ios.png" alt="" srcset=""> 
            <img  v-else src="../../assets/images/ios2.png" alt="" srcset=""    >

           </div>
        </el-drawer>
    </div>


</template>
<style scoped lang='scss'>
* {
    font-family: PingFang SC, microsoft yahei, STHeitiSC-Light, simsun, sans-serif;

}

/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar {
    width: 0.01rem;
    opacity: 0;
    //   display: none;
}

/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
    background-color: #fff;
    opacity: 0;
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
    width: 0.01rem;
    border-radius: 0.01rem;
    opacity: 0;
}

.fixed-box {
    position: fixed;
    bottom: 100px;
    right: 10px;
    z-index: 999;

    >div {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background-color: rgba(255, 255, 255, 0.85);
        ;
        box-shadow: 0px 0px 10px 2px #0000003b;
        margin-bottom: 10px;

        >img {
            width: 20px;
            height: 20px;
            margin: 10px;
        }
    }
}

.pg-top {
    display: flex;
    justify-content: space-between;
    padding: 21px 0 20px;

    .top-l {
        width: 20%;
        min-width: 250px;
        height: 360px;
        margin-right: 20px;
        background-color: #c6372a;
        border-radius: 20px;
        padding: 17px 15px 6px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .hot-title {
            width: 100%;
            font-family: MicrosoftYaHei, MicrosoftYaHei;
            font-weight: bold;
            font-size: 22px;
            color: #FFFFFF;
            line-height: 29px;
            text-align: center;
            font-style: normal;
            margin-top: 10px;
            overflow: hidden;
            /* 隐藏超出部分 */
            white-space: nowrap;
            /* 保持文案在一行显示 */
            text-overflow: ellipsis;
            /* 显示省略号 */
        }

        .hot-group {
            flex: 1;
            display: flex;
            flex-wrap: wrap;

            justify-content: space-between;
            margin-top: 20px;
            width: 100%;

            >div {
                height: 130px;
            }

        }
    }

    .top-r {
        flex: 1;
        height: 360px;
    }
}

.shopping-steps-container {
    max-width: 1440px;
    margin: 0 auto 20px;
    background-image: url('@/assets/images/home-stepbg.png');
    background-repeat: no-repeat;
    background-position: center;
    padding: 40px 29px;
    color: #262626;
    // border: 14px solid #ee722b;
    // background: #f8f8f8;
    // border-radius: 20px;
    background: linear-gradient(165deg, #c03529, rgba(238, 114, 43, 0.6196078431), rgba(234, 195, 173, 0.1098039216), rgba(234, 195, 173, 0), rgb(238 114 43));
    // background: linear-gradient(165deg, #c03529, #ee722b9e, #eac3ad1c, #eac3ad00);

    .step-slogan {

        font-size: 32px;
        line-height: 32px;
        font-weight: 700;
        text-align: center;
        margin-bottom: 60px;
    }

    .step-container {
        display: flex;
        // column-gap: calc((100% - 1368px) / 3);
        justify-content: space-between;

        .step-item {
            display: flex;
            flex-direction: column;
            align-items: center;

            width: 262px;
            padding: 0 20px;
            position: relative;

            .step-icon {
                width: 160px;
                height: 160px;
                margin-bottom: 40px;
                background-image: url('@/assets/images/home-step1.png');
            }

            .icon2 {
                background-image: url('@/assets/images/home-step2.png');
            }

            .icon3 {
                background-image: url('@/assets/images/home-step3.png');
            }

            .icon4 {
                background-image: url('@/assets/images/home-step4.png');
            }

            .step-title {
                margin-bottom: 8px;
                font-weight: 700;
                font-size: 20px;
                line-height: 20px;
                text-align: center;
                font-style: normal;
            }

            .step-content {
                color: #555353;
                line-height: 24px;
                font-size: 14px;
                text-align: left;
            }

            ::after {
                content: "";
                position: absolute;
                right: -127px;
                top: 80px;
                transform: translateY(-50%);
                width: calc(100% - 80px);
                height: 1px;
                background: repeating-linear-gradient(to right, #c92910, #c92910 5px, transparent 5px, transparent 10px);
            }

            ::before {
                content: "";
                position: absolute;
                right: -10px;
                top: 80px;
                transform: translateY(-50%);
                width: 0;
                height: 0;
                border-top: 6px solid transparent;
                border-bottom: 6px solid transparent;
                border-left: 8px solid #c92910;
            }
        }

        .step-item:last-child {
            ::before {
                right: 0;
                top: 0;
                transform: 0;
                width: 0;
                height: 0;
                border-top: none;
                border-bottom: none;
                border-left: none;
            }

            ::after {
                right: 0;
                top: 0;
                transform: 0;
                width: 0;
                height: 0;
                background: none;
            }
        }
    }
}

.shopping-steps-container-phone {
    display: none;
    margin: 0 auto 0px;
    background-image: url('@/assets/images/home-stepbg.png');
    background-repeat: no-repeat;
    background-position: center;
    padding: 20px 0px;
    color: #262626;
    // border: 14px solid #ee722b;
    // background: #f8f8f8;
    // border-radius: 20px;

    // background: linear-gradient(165deg, #c03529, rgba(238, 114, 43, 0.6196078431), rgba(234, 195, 173, 0.1098039216), rgba(234, 195, 173, 0), rgb(238 114 43));
    // background: linear-gradient(165deg, #c03529, #ee722b9e, #eac3ad1c, #eac3ad00);

    .step-slogan {

        font-size: 20px;
        line-height: 26px;
        font-weight: 700;
        text-align: center;
        margin-bottom: 15px;
    }

    .step-container {
        display: flex;
        // column-gap: calc((100% - 1368px) / 3);
        justify-content: space-between;
        // align-items: center;
        flex-wrap: wrap;

        .step-item {
            display: flex;
            flex-direction: column;
            align-items: center;

            width: 25%;
            padding: 10px 0px;
            position: relative;
            ::after {
                content: "";
                position: absolute;
                right: 0px;
                // right: -5px;
                top: 40px;
                transform: translate(50%,-50%);
                width: calc(25vw - 68px);
                height: 1px;
                background: repeating-linear-gradient(to right, #c92910, #c92910 2px, transparent 2px, transparent 4px);
            }

            ::before {
                content: "";
                position: absolute;
                right: 0px;
                top: 40px;
                transform: translate(50%,-50%);
                // transform: translateY(-50%);
                width: 0;
                height: 0;
                border-top: 4px solid transparent;
                border-bottom: 4px solid transparent;
                border-left: 6px solid #c92910;
            }
            .step-icon {
                width: 60px;
                height: 60px;
                margin-bottom: 20px;
                background-image: url('@/assets/images/home-step1.png');
                background-size: cover;
                // position: relative;
            }

            .icon2 {
                background-image: url('@/assets/images/home-step2.png');
            }

            .icon3 {
                background-image: url('@/assets/images/home-step3.png');
            }

            .icon4 {
                background-image: url('@/assets/images/home-step4.png');
            }

          
            .step-title {
                margin-bottom: 4px;
                font-weight: 700;
                font-size: 14px;
                line-height: 16px;
                text-align: center;
                font-style: normal;
            }

            .step-content {
                color: #555353;
                line-height: 20px;
                font-size: 12px;
                text-align: left;
                padding: 0 5px;
            }


        }
        .step-item:last-child {
            ::before {
                right: 0;
                top: 0;
                transform: 0;
                width: 0;
                height: 0;
                border-top: none;
                border-bottom: none;
                border-left: none;
            }

            ::after {
                right: 0;
                top: 0;
                transform: 0;
                width: 0;
                height: 0;
                background: none;
            }
        }

    }
}

.time-sale {


    background: #FB7325;

    .time-line {
        width: 100%;
        height: 80px;
        padding: 20px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .sale-title {
            padding-left: 3px;
            flex: 1;
            font-family: MicrosoftYaHei, MicrosoftYaHei;
            font-weight: bold;
            font-size: 30px;
            color: #FFFFFF;
            line-height: 40px;
            text-shadow: 0px 2px 4px rgba(238, 10, 10, 0.5);
            text-align: left;
            font-style: normal;
            text-transform: uppercase;
        }

        .sale-btn {
            width: 88px;
            height: 36px;
            background: #F44242;
            border-radius: 20px;
            font-family: MicrosoftYaHei;
            font-size: 14px;
            color: #FFFFFF;
            line-height: 36px;
            text-align: center;
            font-style: normal;
        }
    }

    .sale-group {
        width: 100%;
        height: 362px;
        background: #FB5B25;
        padding: 15px 20px 20px;
        box-sizing: border-box;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: center;


    }
}

.banner {

    img {

        image-rendering: pixelated;
        // object-fit: cover;
        width: 100%;
        height: 360px;
        // background-size: cover;
        // object-fit: contain;
        // object-fit: cover; /* 裁剪并覆盖到容器 */

    }
}

.container {

    // background-color: #fff;
    .carouselImg {
        width: 100%;
        height: 100%;
    }

    .theme-list {
        //   margin-top: 12px;
    }

    .fixed-nav {
        padding-top: 20px;
        // border-bottom: 1px solid #eee;
        overflow-x: scroll;
        overflow-y: hidden;

        -webkit-overflow-scrolling: touch;
    }

    .fixed-nav-content {
        display: flex;
    }

    .tab-title {
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #888888;
        line-height: 16px;
        text-align: left;
        font-style: normal;
        margin-right: 30px;
        flex-shrink: 0;
        height: 30px;
        position: relative;
        /* 相对定位 */
    }

    .select-tab {
        font-weight: 600;
        font-size: 20px;
        color: #222222;
        line-height: 18px;
        text-align: left;
        font-style: normal;
    }

    .tab-title.select-tab::after {
        content: '';
        position: absolute;
        left: calc(50% - 10px);
        /* 动态计算 left 的值，使其居中 */
        right: auto;
        /* 禁用 right 的值 */
        bottom: -2px;
        width: 20px;
        height: 4px;
        background: #FC3938;
        border-radius: 2px;
        transition: background-color 0.3s;
        /* 背景色过渡效果 */
    }

}

.content {
    // padding-top: 20px;
    background-color: #fff;
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 14px;

    .goods-list {
        // padding: 0 27px;
        padding: 10px 0;

        // max-height: 732px;
        // overflow-y: scroll;
        .body {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(240px, 0fr));
            grid-auto-rows: 366px;
            grid-gap: 0px;
        }
    }
}

.pg-phone {
    padding: 0 15px;
    box-sizing: border-box;

    .pg-top {
        padding: 0 0 0 0;

        .top-r {
            height: auto;
        }

    }

    .content>.goods-list {
        padding: 10px 0 0 0;
    }
}


@media (max-width: 768px) {
    .banner {
        padding-top: 88px;
        border-radius: 10px;
        overflow: hidden;

        img {
            border-radius: 10px;
            object-fit: cover;
            image-rendering: pixelated;
            // object-fit: cover;
            width: 100%;
            // height: 590px;
            // background-size: cover;
            // object-fit: contain;
            // object-fit: cover; /* 裁剪并覆盖到容器 */

        }
    }

    .shopping-steps-container {
        display: none;
    }

    .shopping-steps-container-phone {
        display: block;
    }

    .el-carousel__container {
        border-radius: 10px !important;
        overflow: hidden !important;
        position: relative;
        height: 150px !important;
    }

    .container {
        background-color: #fff;
        width: 100%;
        padding-top: 0px;
    }

    .content {
        background-color: #fff;
        width: 100%;
        padding-bottom: 80px;

        .goods-list {
            padding: 0 10px;

            .body {
                display: grid;
                grid-template-columns: repeat(auto-fit, minmax(48%, 0fr));
                grid-auto-rows: 320px;
                grid-gap: 10px;
            }
        }
    }
}
</style>
